<template>
    <div id="submissions" class="home-submissions" v-infinite-scroll="loadMore"
         infinite-scroll-distance="200" infinite-scroll-disabled="cantLoadMore"
         @scroll.passive="scrolled">

        <el-card class="box-card" style="margin-bottom: 1rem">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="6" :lg="4">
                    <span style="font-size: small; color: grey">Select Channel</span>
                    <el-select size="small" v-model="channel" placeholder="Select Channel">
                        <el-option
                                v-for="item in channels"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-col>

                <el-col :xs="24" :sm="12" :md="6" :lg="4">
                    <span style="font-size: small; color: grey">Report Status</span>
                    <el-select size="small" v-model="status" placeholder="Select Status">
                        <el-option
                                v-for="item in statuses"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-col>

                <el-col :xs="24" :sm="12" :md="6" :lg="4">
                    <el-tooltip style="margin-top: 18px"
                                content="Refresh"
                                placement="bottom"
                                transition="false"
                                :open-delay="500">
                        <button class="feed-panel-button" @click="refresh">
                            <i class="el-icon-refresh" :class="{'rotate': refreshing}"></i>
                        </button>
                    </el-tooltip>
                </el-col>
            </el-row>
        </el-card>


        <section class="box-typical comments">
            <div class="box-typical-inner ui threaded comments">
                <div v-for="item in items" v-bind:key="item.id" class="v-comment-not-full">
                    <comment :list="item.comment">
                        <template v-slot:data>

                            <el-row :gutter="20" style="padding-top: 1rem">
                                <el-col :span="24">
                                    <el-table size="small"
                                              :data="item.user_reports"
                                              style="width: 100%"
                                              empty-text="Report made by moderator">
                                        <el-table-column
                                                prop="reporter.username"
                                                label="Reporter">
                                        </el-table-column>
                                        <el-table-column
                                                prop="subject"
                                                label="Reason">
                                        </el-table-column>
                                        <el-table-column
                                                prop="description"
                                                label="Description">
                                        </el-table-column>
                                    </el-table>
                                </el-col>
                            </el-row>

                            <div style="padding-top: 10px">
                                <el-button type="success" size="small" round plain
                                           @click.stop="approve(item)"
                                           :disabled="item.status === true">{{ item.status === true ? 'Approved' : 'Approve' }}</el-button>
                                <el-button type="danger" size="small" round plain
                                           @click.stop="disapprove(item)"
                                           :disabled="item.status === false">{{ item.status === false ? 'Disapproved' : 'Disapprove' }}</el-button>
                            </div>
                        </template>
                    </comment>
                </div>
            </div>
        </section>

        <loading v-show="loading"></loading>

        <no-more-items :text="'No more items to load'"
                       v-if="noMoreItems && !nothingFound"></no-more-items>
    </div>
</template>

<script>
    import Helpers from "../../mixins/Helpers";
    import Loading from "../../components/Loading";
    import NoContent from "../../components/NoContent";
    import NoMoreItems from "../../components/NoMoreItems";
    import Comment from "../../components/Comment";

    export default {
        name: "ModeratorComments",

        mixins: [Helpers],

        components: {
            Loading,
            NoContent,
            NoMoreItems,
            Comment
        },

        data() {
            return {
                statuses: [
                    {label: 'All', value: null},
                    {label: 'Solved', value: 1},
                    {label: 'Unsolved', value: 0}
                ],
                status: 0,
                channels: [
                    {value: null, label: 'All'}
                ],
                channel: null,
                sort: null,
                refreshing: false,
            };
        },

        beforeRouteEnter(to, from, next) {
            if (typeof app != 'undefined') {
                app.$Progress.start();
            }

            Store.page.moderator.getData('comments').then(() => {
                next((vm) => {
                    vm.$Progress.finish();
                });
            });
        },

        beforeRouteUpdate(to, from, next) {
            if (to.hash !== from.hash) return;

            Store.page.moderator.clear();

            this.$Progress.start();

            Store.page.moderator.getData('comments').then(() => {
                this.$Progress.finish();
                next();
            });
        },

        beforeRouteLeave(to, from, next) {
            Store.page.moderator.clear();
            next();
        },

        computed: {
            noMoreItems() {
                return Store.page.moderator.noMoreItems;
            },

            nothingFound() {
                return Store.page.moderator.nothingFound;
            },

            loading() {
                return Store.page.moderator.loading;
            },

            page() {
                return Store.page.moderator.page;
            },

            cantLoadMore() {
                return this.loading || this.noMoreItems || this.nothingFound;
            },

            items() {
                return Store.page.moderator.items;
            },
        },

        watch: {
            channel() {
                Store.page.moderator.channel = this.channel;

                this.update();
            },

            status() {
                Store.page.moderator.status = this.status;

                this.update();
            }
        },

        methods: {
            loadMore() {
                Store.page.moderator.getData('comments', this.sort);
            },

            disapprove(item) {
                axios.post('moderator/comments/'+item.comment.id+'/disapprove').then(response => {
                    item.status = false;
                });
            },

            approve(item) {
                axios.post('moderator/comments/'+item.comment.id+'/approve').then(response => {
                    item.status = true;
                });
            },

            update: _.debounce(
                function () {
                    this.$Progress.start();

                    Store.page.moderator.clearData();

                    Store.page.moderator.getData('comments').then(() => {
                        this.$Progress.finish();
                    });
                },
                200,
            ),

            refresh: _.debounce(
                function () {
                    this.refreshing = true;

                    Store.page.moderator.clear();

                    Store.page.moderator.getData('comments', this.status, this.channel).then(() => {
                        this.refreshing = false;
                    }).catch(() => {
                        this.refreshing = false;
                    });
                },
                200,
                {leading: true, trailing: false}
            ),

            getModeratorChannels() {
                axios.get('/moderator/channels/simple').then((response) => {
                    this.channels = [
                        ...this.channels,
                        ...response.data.data
                    ]
                })
            }
        },

        mounted() {
            this.getModeratorChannels();
        }
    }
</script>

<style>
    .inner_nav_height {
        min-height: 29px !important;
    }

    .set_nav {
        height: 48px !important;
        margin-bottom: 25px !important;
    }

    .nav-item {
        padding: 0;
    }

    .nav-p {
        margin-bottom: 1rem;
    }

    .container {
        max-width: none;
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/pages/moderators/Comments.vue